/**
 * menuPageSecaondaire.js
 */

// Import
import "./menuPageSecondaire.scss";
import $ from 'jquery';

/*$(".menu-secondaire .menu .menu-item-has-children .sub-menu li").click(function(){ 
    alert('test');
   /* $(".menu-secondaire .menu .menu-item-has-children .sub-menu").css("display","none")

});*/

/*console.log($(".menu-secondaire .menu .menu-item-has-children .sub-menu li").hasClass("current-item"));*/

/*var $menuElement = $(".menu-secondaire .menu .menu-item-has-children .sub-menu li");
console.log($menuElement );
if ($menuElement.hasClass("current-menu-item")) {
    console.log('BIPBIPBIP');
    .offset().top
}*/

var stickyHeader;
let stickyHeaderTop;
var menuSecondaire;
var menuSecondaireHeightMargin;

stickyCalcul();

$( ".menu-item a" ).on( "click", function() {
    setTimeout(function(){
        stickyCalcul();
      }, 500);
} );

function stickyCalcul(){
    
    stickyHeader = $("#menu-page-secondaire-desktop");
    stickyHeaderTop = stickyHeader.offsetTop;

    menuSecondaire = $("#menu-page-secondaire-desktop");

    menuSecondaireHeightMargin = menuSecondaire.outerHeight(true)+34;

    $( ".test-class" ).css( "top", menuSecondaireHeightMargin+"px" );
}


$(window).on( 'scroll', function(){
    
    
    if( $(document).scrollTop() > stickyHeaderTop-34 ) {
        
        $('#menu-page-secondaire-desktop').css({position: 'sticky', top: '34px'});  
    } else {
        
        $('#menu-page-secondaire-desktop').css({ top: '34px'});
    }
});



